import classNames from 'classnames'
import React, { CSSProperties, FC, MouseEventHandler, SVGProps } from 'react'

import Icon from '../icon/Icon'

import styles from './icon-button.module.scss'

export interface IconButtonProps {
  iconSvg: FC<SVGProps<SVGElement>>
  className?: string
  iconClassName?: string
  onClick?: MouseEventHandler<HTMLButtonElement>
  ariaLabel: string
  innerStyle?: CSSProperties
  dataTestId?: string
  label?: string
}

export const IconButton: FC<IconButtonProps> = ({
  iconSvg: IconSVG,
  onClick,
  className,
  ariaLabel,
  iconClassName,
  innerStyle,
  dataTestId,
  label,
}) => {
  return (
    <button
      className={classNames(styles.iconButton, className)}
      onClick={onClick}
      aria-label={ariaLabel}
      data-testid={dataTestId}
    >
      <Icon iconSvg={IconSVG} className={classNames(iconClassName)} style={innerStyle} />
      {label}
    </button>
  )
}
